import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task03 } from "../../../../../task/course-04/lesson-12/task-03";

const task: Slide = {
  titleHtml: `A shaker has a moving mass of 100 g and an electrical resistance of 2.5 Ω.</br>Deduce the value of its Bℓ factor.`,
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/12/task/task-3.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task03.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
